import { format, isValid } from "date-fns";
import moment from "moment";
import { ptBR } from "date-fns/locale";

export const formatDate = (input: Date): string => {
	const stringDate = input.toLocaleDateString("pt-BR", {
		hour12: false,
		formatMatcher: "basic",
		year: "numeric",
		month: "numeric",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
	const splitDateTime = stringDate.split(" ");
	const datePart = splitDateTime[0];
	const timePart = splitDateTime[1];

	const splitTime = timePart.split(":");

	return `${datePart} ${splitTime[0]}h${splitTime[1]}m`.replace(",", " ");
};

export const formatDateTimeFNS = (date?: Date | string) => {
	if (!date) return "N/A";
	const validDate = new Date(date);
	return isValid(validDate) ? format(validDate, "dd/MM/yyyy HH:mm:ss") : "Data inválida";
};

export const formatDateForInput = (input: Date): string => {
	const yearAsNumber = input.getFullYear();
	const dayAsNumber = input.getDate();
	const monthAsNumber = input.getMonth() + 1;

	const monthAsString = monthAsNumber >= 10 ? monthAsNumber.toString() : "0" + monthAsNumber.toString();
	const dayAsString = dayAsNumber >= 10 ? dayAsNumber.toString() : "0" + dayAsNumber.toString();

	return `${yearAsNumber.toString()}-${monthAsString}-${dayAsString}`;
};

export const formatDateUTC = (data: any, hasHour: boolean = true): string => moment(data).format(`YYYY-MM-DD${hasHour ? " HH:mm" : ""}`);

export const formatDateBR = (data: any, hasHour: boolean = true): string => moment(data).format(`DD/MM/YYYY${hasHour ? " HH:mm" : ""}`);

export const formatDateBRHasMinutes = (data: any, hasHour: boolean = true): string => moment(data).format(`DD/MM/YYYY${hasHour ? " HH:mm:ss" : ""}`);

export const formatToDate = (data: any): Date => {
	if (!data) return new Date();
	else if (typeof data === "string") return moment(new Date(data)).toDate();
	else return moment(data).toDate();
};

export const formatToDateToString = (data: any, hasHour: boolean = true): string => {
	if (!data) return "";
	else if (typeof data === "string") {
		const dateConvert = new Date(data);
		return moment(dateConvert).format(`YYYY-MM-DD${hasHour ? " HH:mm:ss" : ""}`);
	} else {
		return moment(data).format(`YYYY-MM-DD${hasHour ? " HH:mm:ss" : ""}`);
	}
};

/**
 * Formata uma data no padrão "dd/MM/yyyy", removendo a parte de timezone (caso exista)
 * e validando se a data informada é uma data real (excluindo datas como "2025-02-30" ou "2025-04-00").
 *
 * Casos tratados:
 * - `null`, `undefined`, string vazia ou apenas espaços → retorna ""
 * - Datas com timezone ou horas (ex: "2025-04-01T03:00:00Z") → timezone é ignorado
 * - Datas inválidas ou inexistentes → retorna ""
 *
 * @param dateString string contendo uma data no formato ISO (ex: "2025-04-01T03:00:00Z" ou "2025-04-01 03:00:00")
 * @returns string formatada como "dd/MM/yyyy", ou "" caso a data seja inválida
 */
export const formatDateFnsRemoveTimezone = (dateString: string): string => {
	// Verifica se a string existe e não está vazia
	if (!dateString?.trim()) return "";

	// Extrai apenas os primeiros 10 caracteres (YYYY-MM-DD), ignorando horas/timezone
	const [year, month, day] = dateString.substring(0, 10).split("-").map(Number);

	// Cria uma data com os valores extraídos
	const date = new Date(year, month - 1, day); // mês no JS começa em 0

	// Verifica se a data é válida comparando os componentes originais com os da instância Date
	const isValidDate = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;

	if (!isValidDate) return "";

	// Retorna a data formatada no padrão brasileiro
	return format(date, "dd/MM/yyyy", { locale: ptBR });
};
